<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">结算周期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">结算机构</span>
        <selectTree v-model="searchParams.orgIds" type="4" :maxTagCount="1" :multiple="true" ref="selectTreeRef"> </selectTree>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="settlementStatus">
          <div class="settlement-status">
            <span v-if="row.settlementStatus == 0" class="tag-settled">未结算</span>
            <span v-else class="tag-be">已结算</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="toDetailPage(row)">详情</span>
          <span class="table-btn" @click="delRow(row)" v-if="row.settlementStatus == 0">删除</span>
          <span class="table-btn" @click="payment(row)" v-if="row.settlementStatus == 1 && row.orgIdStr.includes(userInfo.organId)">{{ row.refundedStatus == 0 ? '回款' : '取消回款' }}</span>
          <span class="table-btn" @click="toBillDetail(row)">明细</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import { mapState } from 'vuex';

export default {
  mixins: [pageTool, common],
  components: {
    selectTree
  },
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      searchParams: {},
      columns: [
        {
          title: '结算周期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200,
          tooltip: true,
          tooltipMaxWidth: 700
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        },
        {
          title: '总单量',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 130
        },
        {
          title: '费用费用合计',
          align: 'center',
          key: 'netIncome',
          minWidth: 120
        },
        {
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let refundedStatus = params.row.refundedStatus;
            return <span>{refundedStatus == 0 ? '未回款' : '已回款'}</span>;
          },
          renderHeader: (h, params) => {
            return (
              <div>
                <span>是否回款</span>
              </div>
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 180,
          fixed: 'right'
        }
      ],
      total: 0,
      tableData: []
    };
  },
  activated(){
    this.getList();
  },
  created() {
    this.searchAjax();
  },

  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    resetSearch() {
      this.searchParams = {};
      this.searchAjax();
    },

    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      // 结算日期
      if (data.settlementDate && data.settlementDate[0]) {
        data.settlementDateStart = data.settlementDate[0];
        data.settlementDateEnd = data.settlementDate[1];
      }
      delete data.settlementDate;
      this.$http({
        url: '/buz/settlementReport/read/page',
        type: 'POST',
        data: {
          ...data,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: 1
        }
      })
        .then(res => {
          this.total = res.total;
          res.data.forEach(item => {
            item.orgIdStr = item.orgIdStr.split(',');
          });
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    toDetailPage(row) {
      this.openPageTabTags('/orgSettlement/commissionSettlement/subordinateDetail', {
        reportId: row.id,
        reportName: row.reportName,
        settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD'), //结算日期
        orgName: row.orgName
      });
    },

    // 删除
    delRow(row) {
      if (!this.$units.pointAction('offline_82_2_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry(`确认删除操作？`).then(() => {
        this.$http({
          url: '/buz/settlementReport/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
        });
      });
    },

    // 回款/取消回款
    payment(row) {
      this.openPageTabTags('/orgSettlement/commissionSettlement/subordinateDetail', {
        reportId: row.id,
        reportName: row.reportName,
        settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD'), //结算日期
        orgName: row.orgName,
        roll: 1
      });
    },

    // 明细
    toBillDetail(row) {
      this.openPageTabTags('/orgSettlement/commissionSettlement/subordinateBillDetail', {
        reportId: row.id,
        reportName: row.reportName,
        settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD') //结算日期
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  margin-top: 15px;
  .settlement-status {
    display: flex;
    .tag-settled {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 2px;
      font-size: 13px;
      color: #e3461f;
      border: 1px solid #ffc1b2;
      background: #fff5f2;
    }
    .tag-be {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 4px;
      font-size: 13px;
      color: #35bf3f;
      border: 1px solid #abeaae;
      background: #f6fcf4;
    }
  }
}

.label {
  position: relative;
  .tip-icon {
    margin-left: 6px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    bottom: -38px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -50px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 66px;
      transform: rotateZ(135deg);
    }
  }
}
</style>
